import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface VwFieldChange {
  label: string;
  from: string;
  to: string;
}

// Generic "here's what you're about to save" confirmation — presentational
// only, the caller owns computing the diff and what happens on confirm.
@Component({
  selector: 'app-change-confirm-modal',
  templateUrl: 'change-confirm-modal.component.html',
  styleUrls: ['change-confirm-modal.component.scss']
})
export class ChangeConfirmModalComponent {
  @Input() open = false;
  @Input() title = 'Confirm changes';
  @Input() changes: VwFieldChange[] = [];
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
